import { object, string, pattern, size, refine, is } from "superstruct";


/**
 * Contact Form Validation Schema
 * name: alphabetic string
 * phone: numeric, 9–10 digits
 * email: valid email format
 * course: non-empty string
 * message: non-empty string
 */

// Custom validations
const Email = pattern(
  string(),
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
);

const Phone = refine(string(), 'Phone', value => {
  return /^[0-9]{9,10}$/.test(value);
});

const Name = refine(string(), 'Name', value => {
  return /^[A-Za-z\s]+$/.test(value.trim());
});

const NonEmpty = refine(string(), 'NonEmpty', value => value.trim().length > 0);


function validate(data) {
  const validator = object({
    name: Name,
    phone: Phone,
    email: Email,
    course: NonEmpty,
    message: NonEmpty,
  });

  return is(data, validator);
}

export default validate;
